import { createApi } from "@reduxjs/toolkit/query/react";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const AcademicTaskListApi = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'AcademicTaskListApi',
    endpoints: (builder) => ({
        getAcadmicTaskList: builder.mutation({
            query: (details) => ({
                url: '/AcademicMember/GetAllAcademicMembershipTaskList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetAllDropdownsForAcademicMembers: builder.query({
            query: () => ({
                url: encryptQueryString('/Common/GetAllDropdownsForAcademicMembers'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetAllAcedemicInformationDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/AcademicMember/GetAllAcedemicInformationDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        UpdateAcademicMemberDetails: builder.mutation({
            query: (details) => ({
                url: '/AcademicMember/UpdateAcademicMemberDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        RejectAcademicMemberApplication: builder.mutation({
            query: (details) => ({
                url: '/AcademicMember/RejectAcademicMemberApplication',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        SentPaymentLinkAcademicMember: builder.mutation({
            query: (details) => ({
                url: '/AcademicMember/SentPaymentLinkAcademicMember',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        AddEditMembershipPricingByAdmin: builder.mutation({
            query: (details) => ({
                url: '/MembershipPayment/AddEditMembersPricingFromAdminByMemberId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGetAcadmicTaskListMutation,
    useLazyGetAllDropdownsForAcademicMembersQuery,
    useLazyGetAllAcedemicInformationDetailsByIdQuery,
    useUpdateAcademicMemberDetailsMutation,
    useRejectAcademicMemberApplicationMutation,
    useSentPaymentLinkAcademicMemberMutation,
    useAddEditMembershipPricingByAdminMutation
} = AcademicTaskListApi;

export default AcademicTaskListApi;

//commit production